<template>
  <v-dialog
    class='assets-filter-popup'
    :value="visiblePopup"
    :max-width="600"
    @click:outside="onNoClickButton"
    @keydown.esc="onNoClickButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='assets-wrapper'>
        <v-range-slider
          v-model="assetsUpdatedValue"
          :max="maxValue"
          :min="minValue"
          step="1"
          hide-details
          class="align-center"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="assetsUpdatedValue[0]"
              hide-details
              single-line
              type="number"
              variant="outlined"
              density="compact"
              class="slider-value"
            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              v-model="assetsUpdatedValue[1]"
              hide-details
              single-line
              type="number"
              variant="outlined"
              class="slider-value"
              density="compact"
            ></v-text-field>
          </template>
        </v-range-slider>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()">
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import {mapGetters} from 'vuex';

export default {
  name: 'SelectAssetsFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      assetsUpdatedValue: [0, 100],
    };
  },
  watch: {
    minValue() {
      this.assetsUpdatedValue[0] = this.minValue;
    },
    maxValue() {
      this.assetsUpdatedValue[1] = this.maxValue;
    },
    visiblePopup() {
      this.assetsUpdatedValue = [this.minValue, this.maxValue];
    },
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.assetsUpdatedValue);
    },
    onNoClickButton() {
      this.$emit('clicked', false);
    },
  },
  computed: {
    ...mapGetters([
      'topLevelDomainsAssets',
    ]),
    minValue() {
      return this.topLevelDomainsAssets[0]?.min || 0;
    },
    maxValue() {
      return this.topLevelDomainsAssets[0]?.max || 0;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.assets-wrapper {
  .v-text-field.v-text-field {
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(600);
  min-width: rem(600);
  padding: $space-8 $space-10;

  .assets-wrapper {
    min-width: rem(400);
    margin-bottom: rem(-20);

    .slider-value {
      width: rem(65);
      margin-bottom: $space-4;
    }
  }

  .title {
    color: var(--text-primary);
    font-size: $font-size-base !important;
    font-weight: 600;
    letter-spacing: 0.5px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: $space-6;
  }

  .buttons {
    text-align: right;
    padding-top: $space-7;

    .no-button {
      box-sizing: border-box;
      height: $btn-height-md;
      width: rem(86);
      border: $border-width-thin solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      background-color: var(--brand-primary);
      box-shadow: $shadow-sm;
      color: var(--text-inverse);
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}
</style>
